import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ExhibitionFacade } from '@app/exhibition/exhibition.facade';
import { TourType } from '@app/shared/enums/tour-type.enum';
import { TourFacade } from '@app/tour/tour.facade';

@Injectable({
  providedIn: 'root',
})
export class FullRoutingService {
  private readonly router = inject(Router);
  private readonly exhibitionFacade = inject(ExhibitionFacade);
  private readonly tourFacade = inject(TourFacade);

  // It should take the first available exhibtion and the first tour of the type Activity
  public navigateToStationWithExhibtionAndTourSuffix(stationId: string, substationId: string) {
    const firstExhibition = this.exhibitionFacade.allExhibitionsSignal().find(() => true);
    const acitvityTour = this.tourFacade.allToursSignal().find(tour => tour.type === TourType.ACTIVITY);

    if (!firstExhibition || !acitvityTour) {
      return;
    }

    this.router.navigate([
      'exhibition', firstExhibition.id,
      'tour', acitvityTour.id,
      'station', stationId,
      'substation', substationId
    ]);
  }

}
